import { CedeSDKError } from "./base";
import { SdkErrorCodes, SdkErrorMessages } from "./errorsMetadata";

/**
 * @description Default error for deposit
 */
export class DepositError extends CedeSDKError {
  constructor(code = SdkErrorCodes.DEPOSIT_ERROR, message = SdkErrorMessages.DEPOSIT_ERROR) {
    super(code, message);
    this.name = "DepositError";
  }
}

/**
 * @description Thrown when the deposit address is not found from the exchange api
 */
export class GetDepositAddressError extends DepositError {
  constructor(tokenSymbol: string, network?: string) {
    super(SdkErrorCodes.GET_DEPOSIT_ADDRESS, SdkErrorMessages.GET_DEPOSIT_ADDRESS(tokenSymbol, network));
    this.name = "GetDepositAddressError";
  }
}

export class CreateDepositAddressError extends DepositError {
  constructor(tokenSymbol: string, network?: string) {
    super(SdkErrorCodes.CREATE_DEPOSIT_ADDRESS, SdkErrorMessages.CREATE_DEPOSIT_ADDRESS(tokenSymbol, network));
    this.name = "CreateDepositAddressError";
  }
}

export class DepositAddressAlreadyExistsError extends DepositError {
  constructor() {
    super(SdkErrorCodes.DEPOSIT_ADDRESS_ALREADY_EXISTS, SdkErrorMessages.DEPOSIT_ADDRESS_ALREADY_EXISTS);
    this.name = "DepositAddressAlreadyExistsError";
  }
}

/**
 * @description Thrown when the deposit tx is not found
 */
export class DepositNotFoundError extends DepositError {
  constructor() {
    super(SdkErrorCodes.DEPOSIT_NOT_FOUND, SdkErrorMessages.DEPOSIT_NOT_FOUND);
    this.name = "DepositNotFoundError";
  }
}
